// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setSeconds as fn } from "../setSeconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setSecondsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default setSecondsWithOptions;
